import { useEffect } from 'react';
import { useAtom } from 'jotai';
import { userRecordAtom, lastActiveUpdateAtom } from '../state/atoms';
import { useUserService } from '../services';

export default function useLastActiveUpdate() {
  const { updateUser } = useUserService();
  const [userState] = useAtom(userRecordAtom);
  const [lastActiveUpdate, setLastActiveUpdate] = useAtom(lastActiveUpdateAtom);

  useEffect(() => {
    const now = new Date();
    const thirtyMinutes = 30 * 60 * 1000;

    if (!lastActiveUpdate || now - new Date(lastActiveUpdate) > thirtyMinutes) {
      updateUser(userState.id, { 'meta.lastActiveDate': now });
      setLastActiveUpdate(now.toISOString());
    }
  }, [userState.id, lastActiveUpdate, setLastActiveUpdate]);
}
